import { render, staticRenderFns } from "./ai-report.vue?vue&type=template&id=3e5076be&scoped=true&"
import script from "./ai-report.vue?vue&type=script&lang=js&"
export * from "./ai-report.vue?vue&type=script&lang=js&"
import style0 from "./ai-report.vue?vue&type=style&index=0&id=3e5076be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5076be",
  null
  
)

component.options.__file = "ai-report.vue"
export default component.exports